import { useContext } from 'react';

import { ComplaintDeviceContext } from 'context/ComplaintDeviceContext';

export const SCREEN_MIN_WIDTH = 1024; // Yoga breakpoint max width for medium devices

export default function useCompliantDevice() {
  const context = useContext(ComplaintDeviceContext);

  if (!context) {
    throw new Error('useCareMatrix must be used within an CareMatrixProvider');
  }

  return context;
}
